import styled from 'styled-components';

export const Box = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 1.6rem;
  margin: 1rem;
  border-radius: 1.6rem;
  max-width: 37.5rem;

  display: flex;
  flex-direction: column;
`;

export const Text = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
`;

export const Divider = styled.hr`
  margin: 3rem;
  color: ${({ theme }) => theme.colors.grayBorder};
  width: 20rem;
  align-self: center;
`;
